// set hidden value on the notification dialog with a date it was updated
// check the date 

(() => {
    const notification = 'NEW_NOTIFICATION'
    const cookieStorage = {
        getItem: (key) => {
            const cookies = document.cookie
                .split(";")
                .map((cookie) => cookie.split("="))
                .reduce(
                    (acc, [key, value]) => ({ ...acc, [key.trim()]: value }),
                    {}
                );
            return cookies[key];
        },
        setItem: (key, value) => {
            document.cookie = `${key}=${value}; path=/`; 
        }
    };

    let current_date = document.querySelector('[data-date]')?.dataset?.date 
    const notification_icon = document.querySelector('.header__icon-notifications')
    const notification_icon_red_dot = notification_icon.querySelector('svg circle')

    notification_icon.addEventListener('click', e => {
        notification_icon_red_dot.style.display = "none"
        cookieStorage.setItem(notification,JSON.stringify(current_date));
    })

    const customer_last_notification = cookieStorage.getItem(notification)

    if(customer_last_notification !== undefined) {

        if(current_date !== JSON.parse(customer_last_notification)) {
            cookieStorage.setItem(notification,JSON.stringify(current_date));
            notification_icon_red_dot.style.display = "block"
        }
    } else  notification_icon_red_dot.style.display = "block"

})();